import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${import.meta.env.VITE_BACKEND_URL}/api`;

/**
 * Defaults dos links PÚBLICOS — usados enquanto o GET não responde (ou se o
 * backend ainda não tiver a tabela platform_settings). Os grupos de WhatsApp
 * NÃO ficam aqui: são exclusivos de plano pago (ver useCommunityGroups).
 */
export const DEFAULT_PLATFORM_SETTINGS = {
  community_discord_url: 'https://discord.gg/uV9Y8YvW',
};

/**
 * usePlatformSettings — configurações públicas da plataforma (Discord). GET
 * público; saveSetting é restrito a super admin no backend
 * (PUT /api/platform-settings) — a UI só mostra edição pra super admin.
 */
export default function usePlatformSettings() {
  const [settings, setSettings] = useState(DEFAULT_PLATFORM_SETTINGS);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/platform-settings`)
      .then((res) => {
        if (!cancelled && res.data && res.data.settings) {
          setSettings((prev) => ({ ...prev, ...res.data.settings }));
        }
      })
      .catch(() => { /* mantém defaults */ });
    return () => { cancelled = true; };
  }, []);

  const saveSetting = useCallback(async (key, value) => {
    const token = localStorage.getItem('token');
    const res = await axios.put(`${API}/platform-settings`, { key, value }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.data && res.data.settings) {
      setSettings((prev) => ({ ...prev, ...res.data.settings }));
    }
  }, []);

  return { settings, saveSetting };
}
